import { render, staticRenderFns } from "./SampleHistory.vue?vue&type=template&id=4572a088&scoped=true"
import script from "./SampleHistory.vue?vue&type=script&lang=js"
export * from "./SampleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4572a088",
  null
  
)

export default component.exports